module.exports = __webpack_public_path__ + "static/ernest-hemingway-2297f4f30d5726f4897ba87b9587f1eb.jpg";